import { render, staticRenderFns } from "./publicPlaceManage.vue?vue&type=template&id=5f48efc0"
import script from "./publicPlaceManage.vue?vue&type=script&lang=js"
export * from "./publicPlaceManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports